import { combineReducers } from 'redux';
import loginReducer from './reducers/loginReducer';
import permissionsReducer from './reducers/permissionsReducer';
import userReducer from './reducers/userReducer';
import roleReducer from './reducers/roleReducer';
import organizationReducer from './reducers/organizationReducer';
import moduleReducer from './reducers/moduleReducer';
import pollingAgentReducer from './reducers/pollingAgentReducer';
import campaignReducer from './reducers/campaignReducer';
import campaignTemplateReducer from './reducers/campaignTemplateReducer';
import surveyReducer from './reducers/surveyReducer';
import surveyRespondentReducer from './reducers/surveyRespondentReducer';
import projectReducer from './reducers/projectReducer';
import chatReducer from './reducers/chatReducer';
import emailInviteReducer from './reducers/emailInviteReducer';
import folderReducer from './reducers/folderReducer';
import settingReducer from './reducers/settingReducer';

const rootReducer = combineReducers({
  login: loginReducer,
  permissions: permissionsReducer,
  user: userReducer,
  role: roleReducer,
  organization: organizationReducer,
  module: moduleReducer,
  pollingAgent: pollingAgentReducer,
  campaign: campaignReducer,
  campaignTemplate: campaignTemplateReducer,
  survey: surveyReducer,
  surveyRespondent: surveyRespondentReducer,
  project: projectReducer,
  chat: chatReducer,
  emailInvite: emailInviteReducer,
  folder: folderReducer,
  setting: settingReducer,
});

export default rootReducer;

